import { TableColumn } from './TableHeader.types';

export const tableColumnConfigs: Record<string, TableColumn[]> = {
  AISystemOverview: [
    {
      label: 'SYSTEM NAME',
      width: 'min-w-56',
      sortable: true,
      sortKey: 'name',
      className: 'w-full'
    },
    {
      label: 'ENTITY',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'entity',
      className: 'w-full'
    },
    {
      label: 'COMPLIANCE STATUS',
      width: 'min-w-44',
      sortable: true,
      sortKey: 'complianceStatus',
      className: 'w-full'
    },
    {
      label: 'RISK CLASSIFICATION',
      width: 'min-w-44',
      sortable: true,
      sortKey: 'riskClassification',
      className: 'w-full'
    },
    {
      label: 'OWNER',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'owner',
      className: 'w-full'
    },
    // Two different things used to be labelled "Organization". `account` is the
    // owning tenant (a real entity with an id); `organization` is the free-text
    // provider entity name captured in the questionnaire.
    {
      label: 'ORGANIZATION',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'account',
      className: 'w-full'
    },
    {
      label: 'PROVIDER ORGANIZATION',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'organization',
      className: 'w-full'
    }
  ],
  RepositoryManagement: [
    { label: 'REPOSITORY', width: 'w-1/4', sortable: true, sortKey: 'name' },
    { label: 'PROVIDER', width: 'w-1/6', sortable: true, sortKey: 'provider' },
    {
      label: 'BRANCH',
      width: 'w-1/6 min-w-[170px]',
      sortable: true,
      sortKey: 'branch'
    },
    { label: 'STATUS', width: 'w-1/6', sortable: true, sortKey: 'status' },
    {
      label: 'LAST SYNCED',
      width: 'w-1/5',
      sortable: true,
      sortKey: 'lastSynced'
    },
    { label: 'ACTIONS', width: 'w-32' }
  ],
  // Registered users and pending invitations share one flat list, so every
  // column has to make sense for both — hence STATUS rather than a section
  // divider. Sort keys must match the server's allowlist exactly: an
  // unrecognised one is a 400.
  RegisteredUsers: [
    {
      label: 'NAME',
      width: 'min-w-48',
      sortable: true,
      sortKey: 'name',
      className: 'w-full'
    },
    {
      label: 'EMAIL',
      width: 'min-w-56',
      sortable: true,
      sortKey: 'email',
      className: 'w-full'
    },
    {
      label: 'ORGANIZATION',
      width: 'min-w-40',
      sortable: true,
      sortKey: 'organization',
      className: 'w-full'
    },
    {
      label: 'ROLE',
      width: 'min-w-32',
      sortable: true,
      sortKey: 'platformRole',
      className: 'w-full'
    },
    {
      label: 'Assigned ai systems',
      width: 'min-w-36',
      sortable: true,
      sortKey: 'assignedAiSystems',
      className: 'w-full'
    },
    {
      label: 'STATUS',
      width: 'min-w-32',
      sortable: true,
      sortKey: 'status',
      className: 'w-full'
    },
    {
      label: 'Last Active',
      width: 'min-w-36',
      sortable: true,
      sortKey: 'lastActive',
      className: 'w-full'
    }
  ],
  Documentation: [
    { label: 'TITLE', sortable: true, sortKey: 'fileName', width: 'w-1/3' },
    { label: 'SOURCE', sortable: true, sortKey: 'source', width: 'w-1/6' },
    { label: 'CATEGORY', sortable: true, sortKey: 'category', width: 'w-1/4' },
    {
      label: 'DATE CREATED',
      sortable: true,
      sortKey: 'createdAt',
      width: 'w-1/5'
    },
    { label: 'ACTIONS', width: 'w-32' }
  ]
};
